import { ENVIRONMENTS } from 'services/getEnvironmentalVariables';
import { config } from '../../config';
import { getAppDomains } from '../domain';

export const getCookie = (key: string): string | undefined => document.cookie
    .split('; ')
    .find(pair => pair.startsWith(`${key}=`))
    ?.split('=')[1];

export const setCookie = (key: string, value: string, attributes: string = 'path=/') => {
    document.cookie = `${key}=${value}; ${attributes}`;
};

export const removeCookie = (key: string) => {
    document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

const removeCookieWithDomain = (key: string, domain?: string) => {
    const attributes = ['path=/', 'expires=Thu, 01 Jan 1970 00:00:00 GMT'];
    if (domain) {
        attributes.push(`domain=${domain}`);
    }
    document.cookie = `${key}=; ${attributes.join('; ')}`;
};

/**
 * Detects and removes duplicate cookies, keeping only the cross-domain one
 */
export const cleanupDuplicateCookies = (key: string) => {
    const isLocal = config.environment === ENVIRONMENTS.DEV;

    if (isLocal) return;

    const matchingCookies = document.cookie
        .split('; ')
        .filter(pair => pair.startsWith(`${key}=`));

    if (matchingCookies.length > 1) {
        const domains = getAppDomains();
        domains.forEach(domain => {
            removeCookieWithDomain(key, domain);
        });

        removeCookie(key);
    }
};

export const setCrossDomainCookie = (
    key: string,
    value: string,
    maxAge: number = 2592000,
) => {
    const isLocal = config.environment === ENVIRONMENTS.DEV;

    const domain = isLocal ? '' : '.northspyre.com';

    cleanupDuplicateCookies(key);

    const attributes = [
        'path=/',
        isLocal ? 'SameSite=Lax' : 'SameSite=None',
        `Max-Age=${maxAge}`,
    ];

    if (!isLocal) {
        attributes.push('Secure');
    }

    if (domain) {
        attributes.push(`domain=${domain}`);
    }

    setCookie(key, value, attributes.join('; '));
};
